import { render } from "./CustomerAccountDetails.vue?vue&type=template&id=0beec55a"
import script from "./CustomerAccountDetails.vue?vue&type=script&lang=js"
export * from "./CustomerAccountDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AccountReceivable/CustomerAccountDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0beec55a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0beec55a', __exports__)) {
    api.reload('0beec55a', __exports__)
  }
  
  module.hot.accept("./CustomerAccountDetails.vue?vue&type=template&id=0beec55a", () => {
    api.rerender('0beec55a', render)
  })

}


export default __exports__